import { z } from 'zod'
import { lenient, timestampToDateNullable } from '@upadelmatch/core'

// `match_invites/{matchId_toUid}` — organizer → player invitation (spec/02).
// Deterministic id: a re-invite overwrites instead of duplicating (and the
// push CF only fires on CREATE, so overwrites stay silent). Denormalized
// place/day/time feed the push copy + the invite strip without a match read.
export const INVITE_STATUSES = ['pending', 'accepted', 'declined'] as const

export const MatchInviteSchema = z.object({
  id: z.string(),
  matchId: z.string(),
  fromUid: z.string(),
  fromName: z.string().default(''),
  toUid: z.string(),
  status: lenient(z.enum(INVITE_STATUSES), 'pending', 'matchInvite.status').default('pending'),
  place: z.string().nullable().optional(),
  day: z.string().nullable().optional(),
  time: z.string().nullable().optional(),
  createdAt: timestampToDateNullable,
  updatedAt: timestampToDateNullable,
})

export type MatchInviteDoc = z.output<typeof MatchInviteSchema>

/** One doc per (match, invitee) — idempotent re-invites. */
export function inviteDocId(matchId: string, toUid: string): string {
  return `${matchId}_${toUid}`
}
